import {
    AfterViewInit,
    Directive,
    ElementRef,
    HostListener,
    inject,
    Renderer2,
} from '@angular/core';

@Directive({
    selector: '[wfeAutoTooltip]',
})
export class AutoTooltipDirective implements AfterViewInit {
    private resizeObserver!: ResizeObserver;

    private readonly el = inject(ElementRef);
    private readonly renderer = inject(Renderer2);

    ngAfterViewInit(): void {
        this.initResizeObserver();

        setTimeout(() => this.updateTooltip(), 1000);
    }

    @HostListener('window:resize')
    onResize() {
        this.updateTooltip();
    }

    private updateTooltip() {
        const element = this.el.nativeElement;
        if (element.offsetWidth < element.scrollWidth) {
            this.renderer.setAttribute(
                element,
                'title',
                element.textContent.trim(),
            );
        } else {
            this.renderer.removeAttribute(element, 'title');
        }
    }

    private initResizeObserver() {
        this.resizeObserver = new ResizeObserver(() => {
            this.updateTooltip();
        });

        this.resizeObserver.observe(this.el.nativeElement);
    }
}
